import { callApi } from 'modules/core/api/services'
import { BASE_URL } from 'modules/core/constants'

export const verifyToken = (token: string) =>
  callApi(`/v2/sso_verifications`, 'GET', null, token)

export const refreshToken = async (refreshToken: string) => {
  const { tokens } = await callApi(
    `/v2/sso_verifications/${refreshToken}`,
    'PUT',
    {},
    undefined
  )

  return tokens
}

export const verifyCode = async (code: string) => {
  const response = await callApi(
    `/v2/sso_verifications/${code}?redirect_uri=${BASE_URL}/verify-code`
  )
  const isError = 'error' in response

  if (isError) {
    const errorMessage = response.errorDescription ?? response.error
    throw errorMessage
  }

  return response
}
